var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DriveItemDetails } from '@web/components/ItemDetails/DriveItemDetails/DriveItemDetails';
import { MeetItemDetails } from '@web/components/ItemDetails/MeetItemDetails/MeetItemDetails';
import NotFoundView from '@web/pages/layout/NotFoundView/NotFoundView';
import { Page } from '@web/pages/layout/Page';
import { getUrl } from '@web/router/getUrl';
import { appsUrl } from '@web/router/urls';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { appsActiveTabs } from '@web/utility/tabs';
import { ApplicationEnum } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
export var ItemDetailsView = function () {
    var app = useFilters().app;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var getItemDetails = function () {
        switch (app) {
            case ApplicationEnum.DRIVE:
                return _jsx(DriveItemDetails, {});
            case ApplicationEnum.MEET:
                return _jsx(MeetItemDetails, {});
            default:
                return _jsx(NotFoundView, {});
        }
    };
    var handleBackToList = function () {
        var pathname = app === ApplicationEnum.DRIVE
            ? getUrl(appsUrl, appsActiveTabs.driveAdvancedSearch)
            : getUrl(appsUrl, appsActiveTabs.searchMeetings);
        navigateTo({
            pathname: pathname
        });
    };
    return (_jsx(Page, { children: _jsxs("div", __assign({ className: "flex flex-col gap-4" }, { children: [_jsx("div", __assign({ className: "flex items-center gap-2 text-sm leading-5 font-medium text-indigo-600" }, { children: _jsx("button", __assign({ onClick: handleBackToList }, { children: t('driveItemDetails.backToList') })) })), getItemDetails()] })) }));
};
